'use client';

import { useState } from 'react';
import { ebuiltData } from './IconData';
import { analytics } from '@/utils/analytics';

const Cutaway = () => {
  const [showData, setShowData] = useState(0);

  const displayData = () => {
    return showData > 0 ? (
      <div
        className={`zoom-${showData} absolute left-[5%] top-1/3 z-[1] block max-w-[200px] bg-white md:left-0 md:top-0 md:mt-10 lgDesktop:mt-[7.5rem] [@media(min-width:375px)]:top-[40%] [@media(min-width:900px)]:mt-[5.5rem]`}
      >
        <button
          className="relative -top-2.5 left-[95%] h-5 w-5 cursor-pointer rounded-[50%] border-none bg-clayton-blue text-center font-helveticaNeueNormal text-[12px] font-bold text-white"
          onClick={() => {
            setShowData(0);
            analytics?.track('Modal Closed', {
              source: 'eBuilt Cutaway',
              item: ebuiltData[showData - 1].panelTitle,
            });
          }}
        >
          X
        </button>
        <div>
          <img
            src={`/public-assets/cutaway/zoomed/zoomed-${showData}.png`}
            alt={ebuiltData[showData - 1].panelTitle}
            className="relative left-0 top-0 block h-auto w-full max-w-full"
          />
        </div>
        <div className="bg-[#1CB1FF] py-[10%] text-center">
          <h4 className="font-helveticaNeueBold text-[16px] font-extrabold leading-5 text-white">
            {ebuiltData[showData - 1].panelTitle}
          </h4>
        </div>
        <div
          className="bg-clayton-blue p-[15px] font-helveticaNeueNormal text-white"
          dangerouslySetInnerHTML={{
            __html: ebuiltData[showData - 1].panelBody,
          }}
        />
      </div>
    ) : null;
  };

  return (
    <div className="font-helveticaNeueNormal text-[14px] leading-[1.42851743]">
      <div className="relative">
        <div className="absolute left-0 top-0 w-full">
          <img
            id="eBuilt"
            src="/public-assets/cutaway/ebuilt.png"
            alt="eBuilt"
            className="eBuilt relative left-0 top-0 ml-[78%] mt-[5px] w-full max-w-[16%] [@media(min-width:550px)]:mt-[15px] [@media(min-width:550px)]:max-w-[17.5%]"
          />
        </div>
        <img
          id="cwHome"
          src="/public-assets/cutaway/cutaway.png"
          alt="Cutaway"
          className="img-responsive relative left-0 top-0 w-full"
        />
        {ebuiltData.map((data, index) => (
          <div
            className={`flag-${index + 1} absolute -mt-[2.65rem] inline-flex h-5 w-5 cursor-pointer rounded-[50%] bg-[url(/public-assets/cutaway/eBlurb.png)] bg-cover bg-center bg-no-repeat lgDesktop:-mt-[8.65%] [@media(min-width:1100px)]:-mt-[7.15%] [@media(min-width:440px)]:-mt-[3.35rem] [@media(min-width:440px)]:h-[25px] [@media(min-width:440px)]:w-[25px] [@media(min-width:600px)]:-mt-[9.1%] [@media(min-width:600px)]:ml-[1%] [@media(min-width:900px)]:-mt-[8.95%]`}
            id={`flag-${index + 1}`}
            key={index}
            onClick={() => {
              setShowData(index + 1);
              analytics?.track('Modal Opened', {
                source: 'eBuilt Cutaway',
                item: ebuiltData[index].panelTitle,
              });
            }}
          ></div>
        ))}
        <div id="zoomContainer">{displayData()}</div>
      </div>
    </div>
  );
};

export default Cutaway;
